import { useState, useCallback } from 'react';
import { kycApi } from '@/api/kyc';
import { kycHelpers } from '@/utils/helpers/kyc';
import { STATUS } from '@/utils/static/kyc';

export const useRejectedQuestions = ({
  entityType,
  adminView,
  investorId
}) => {
  const [rejectedQuestions, setRejectedQuestions] = useState(null);
  const [rejectedSectionsIndexes, setRejectedSectionsIndexes] = useState(null);

  const processRejectedQuestions = useCallback(
    async (entity, status, showErrorToast, hideLoader) => {
      try {
        if (status === STATUS.QUESTION_UNACCEPTED || status === STATUS.REJECTED) {
          let rejectedQuestionsData = null;

          if (entityType === 'product') {
            const res = adminView
              ? await kycApi.getRejectedProductEntitiesForAdmin(investorId)
              : await kycApi.getRejectedProductEntities();
            rejectedQuestionsData = res?.data?.question;
          } else if (entityType === 'questionnaire') {
            const res = adminView
              ? await kycApi.getRejectedEntitiesForAdmin(investorId)
              : await kycApi.getRejectedEntities();
            rejectedQuestionsData = res?.data?.question;
          }

          if (rejectedQuestionsData) {
            const { rejectedObj, sectionsIndexes } = kycHelpers.getRejectedObjectUniversal(
              entity,
              rejectedQuestionsData,
              entityType
            );

            if (rejectedObj) {
              setRejectedQuestions(rejectedObj);
            }

            if (status === STATUS.QUESTION_UNACCEPTED && sectionsIndexes.length > 0) {
              setRejectedSectionsIndexes(sectionsIndexes);
            }

            return { rejectedObj, sectionsIndexes };
          }
        }
      } catch (e) {
        if (showErrorToast) {
          showErrorToast(e, true);
        }
        throw e;
      } finally {
        if (hideLoader) {
          hideLoader();
        }
      }
    },
    [entityType, adminView, investorId]
  );

  return {
    rejectedQuestions,
    setRejectedQuestions,
    rejectedSectionsIndexes,
    setRejectedSectionsIndexes,
    processRejectedQuestions
  };
};

